<template>
  <v-icon
    small
    left
    class="close-icon"
    color="grey"
    @click="$emit('remove')"
    outline
    >mdi-close-circle</v-icon
  >
</template>

<script>
export default {
  name: 'BtnRemove',
  data() {
    return {}
  },
}
</script>
